export default __webpack_public_path__ + "static/media/spouseIcon.53f3cba2.png";